import React from 'react'

import { cx } from '@/lib/cva-config'
import { FormControl, FormItem, FormLabel, FormMessage } from '../form'

interface FormFieldsetProps
  extends Omit<React.ComponentProps<typeof FormItem>, 'label'> {
  hideLabel?: boolean
  hideFormMessage?: boolean
  label: string
  noFormControl?: boolean
  isRequired?: boolean
}

export function FormFieldset(props: FormFieldsetProps) {
  const {
    className,
    hideLabel,
    hideFormMessage,
    noFormControl,
    label,
    children,
    isRequired,
    ...rest
  } = props
  const Wrap = noFormControl ? React.Fragment : FormControl

  return (
    <FormItem
      {...rest}
      className={cx('flex flex-col gap-2 space-y-0', className)}
    >
      <FormLabel
        className={cx(
          'w-fit text-sm font-normal',
          hideLabel ? 'sr-only' : '',
          className
        )}
      >
        {label} {isRequired && <span className="text-red-500">*</span>}
      </FormLabel>
      <Wrap>{children}</Wrap>
      {!hideFormMessage && <FormMessage className="text-xs" />}
    </FormItem>
  )
}
